import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';
import {HttpStatusCodes, helixProjectImportStatus} from '../../util/uiconstants';
import _ from 'lodash';

export default function engagementhelixreducer(state = initialState.engagementHelixProjects, action) {
	switch (action.type) {
		case actions.GET_AVAILABLE_PROJECT_FROM_CANAVS_ENGAGEMENT: {
			if (!action.error) {
				const helixData = getHelixProjectAttributes(action.response);
				return [{isLoadedAvailableHelixProjects: true}, ...(helixData || state)];
			}
			return state;
		}
		case actions.UPDATE_HELIX_PROJECT: {
			let newState = _.cloneDeep(state);

			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let updatedHelixProject = newState.find((helixProject) => helixProject.projectId === action.projectId);
				if (updatedHelixProject) {
					updatedHelixProject.helixProjectAttributesReadModel = action.data.helixProjectAttributes;
				}
			}
			return newState;
		}
		case actions.IMPORT_HELIX_PROJECT: {
			let newImportState = _.cloneDeep(state);
			let updatedHelixProject = newImportState.find((helixProject) => helixProject.projectId === action.projectId);
			if (updatedHelixProject) {
				if (action.error) {
					updatedHelixProject.helixImportStatusID = helixProjectImportStatus.Error;
				} else {
					updatedHelixProject.helixImportStatusID = helixProjectImportStatus.InProgress;
				}
			}
			return newImportState;
		}
		case actions.DELETE_IMPORT_HELIX_PROJECT: {
			let newDeleteImportState = _.cloneDeep(state);
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let project = newDeleteImportState.find((helixProject) => helixProject.projectId === action.projectId);
				if (project) {
					project.helixImportUserName = '';
					project.helixImportDate = null;
					project.helixImportStatusID = null;
				}
			}
			return newDeleteImportState;
		}
		case actions.CLEANUP_ENGAGEMENT_HELIX_PROJECTS_STATE: {
			return initialState.engagementHelixProjects;
		}
		default:
			return state;
	}
}

function getHelixProjectAttributes(helixConnections) {
	let result = [];
	helixConnections.map((helixConnection) => {
		const projectAttributes = {
			engagementHelixId: helixConnection?.connections?.engagementHelixId,
			projectId: helixConnection?.connections?.projectId,
			projectName: helixConnection?.connections?.projectName,
			isPrimary: helixConnection?.trialBalanceTypeId === 1 ? true : false,
			helixJson: null,
			helixImportDate: null,
			helixImportUserID: null,
			helixImportUserName: '',
			helixImportStatusID: null,
			helixProjectAttributesReadModel: {
				currencyType: helixConnection?.trialBalanceAttributeJson?.currencyType,
				currencyCode: helixConnection?.trialBalanceAttributeJson?.currencyCode,
				roundingNumber: helixConnection?.trialBalanceAttributeJson?.roundingNumber,
				businessUnit: helixConnection?.trialBalanceAttributeJson?.businessUnit,
				isAllBusinessUnitSelected: helixConnection?.trialBalanceAttributeJson?.isAllBusinessUnitSelected,
				projectCountryCode: helixConnection?.trialBalanceAttributeJson?.isAllBusinessUnitSelected,
				projectRegion: helixConnection?.trialBalanceAttributeJson?.projectRegion,
				projectSubscriptionId: helixConnection?.trialBalanceAttributeJson?.projectSubscriptionId,
				analysisPeriod: helixConnection?.trialBalanceAttributeJson?.analysisPeriod,
				comparativePeriod: helixConnection?.trialBalanceAttributeJson?.comparativePeriod,
				secondComparativePeriod: helixConnection?.trialBalanceAttributeJson?.secondComparativePeriod,
				connectionTypes: helixConnection?.trialBalanceAttributeJson?.connectionTypes,
				businessUnits: helixConnection?.trialBalanceAttributeJson?.businessUnits,
				stEntityBusinessUnits: helixConnection?.trialBalanceAttributeJson?.stEntityBusinessUnits
			},
			helixJsonModel: null,
			isRetryAllowed: false,
			helixAnalyzerId: helixConnection?.connections?.helixAnalyzerID,
			helixAnalyzerName: helixConnection?.connections?.helixAnalyzerName,
			helixAnalyzerType: helixConnection?.connections?.helixAnalyzerType,
			hasClientAnalytics: null,
			customName: helixConnection?.connections?.customName,
			trialBalances: helixConnection?.trialBalanceAttributeJson,
			uniqueId: helixConnection?.connections?.connectionUniqueIdentifier
		};
		result.push(projectAttributes);
	});

	return result;
}
